import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Stream = loadable(() => pMinDelay(import('./Stream'), 300), {
  fallback: <Loading />
});

const AsyncStream = props => {
  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation bg-solid-grey auto-height`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Stream { ...props }/>
    </ApplicationLayout>
  );
};

AsyncStream.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncStream;
